import {
    DarkMode,
    LightMode,
    Menu,
    MenuList,
    MenuProps,
    Portal,
} from '@chakra-ui/react';
import { ComponentProps } from 'react';

export interface ActionMenuProps extends MenuProps {
    children: React.ReactNode;
    menuButton: React.ReactNode;
    menuListProps?: ComponentProps<typeof MenuList>;
    mode?: 'dark' | 'light';
    usePortal?: boolean;
}

const ActionMenu = ({
    children,
    menuButton,
    menuListProps,
    mode = 'light',
    usePortal = true,
    ...menuProps
}: ActionMenuProps) => {
    const Mode = mode === 'light' ? LightMode : DarkMode;

    const MenuContent = (
        <MenuList zIndex={2000} {...menuListProps}>
            {children}
        </MenuList>
    );

    return (
        <DarkMode>
            <Menu placement="bottom-end" autoSelect={false} {...menuProps}>
                <Mode>{menuButton}</Mode>
                {usePortal ? <Portal>{MenuContent}</Portal> : MenuContent}
            </Menu>
        </DarkMode>
    );
};

export default ActionMenu;
